import React from "react";
import styles from "./Toast.module.css";
import {
  FiCheckCircle,
  FiXCircle,
  FiInfo,
  FiAlertTriangle,
  FiX,
} from "react-icons/fi";

export type ToastType = "success" | "error" | "info" | "warning";

interface IToastProps {
  message: string;
  type?: ToastType;
  onClose: () => void;
}

const iconMap = {
  success: (
    <FiCheckCircle className={styles.icon} color="var(--primary-color)" />
  ),
  error: <FiXCircle className={styles.icon} color="#d32f2f" />,
  info: <FiInfo className={styles.icon} color="#1976d2" />,
  warning: <FiAlertTriangle className={styles.icon} color="#fbc02d" />,
};

const Toast: React.FC<IToastProps> = ({ message, type = "info", onClose }) => {
  return (
    <div className={`${styles.toast} ${styles[type]}`}>
      <span className={styles.iconWrapper}>{iconMap[type]}</span>
      <span className={styles.message}>{message}</span>
      <button
        className={styles.closeButton}
        onClick={onClose}
        aria-label="Close notification"
      >
        <FiX />
      </button>
    </div>
  );
};

export default Toast;
